module.exports = __webpack_public_path__ + "static/media/info.8562ad58.svg";